import { useState } from "react";
import { toast } from "sonner";
import { Compass, Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tc_admin_token", data.token);
      toast.success("Welcome back.");
      onSuccess();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-4">
      <div className="w-full max-w-md rounded-2xl border border-goldline bg-panel/80 p-8 backdrop-blur-xl sm:p-10">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/40 bg-gold/10">
            <Compass className="text-gold" size={18} />
          </span>
          <span className="font-serif text-xl font-semibold text-cream">
            Tourism<span className="text-gold"> Connect</span>
          </span>
        </div>
        <h1 className="mt-8 font-serif text-3xl font-semibold text-cream">Admin sign in</h1>
        <p className="mt-2 text-sm text-muted">Leads, subscribers and exports — partners only.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <input
            data-testid="admin-login-email-input"
            type="email"
            required
            placeholder="Admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="field"
          />
          <input
            data-testid="admin-login-password-input"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="field"
          />
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="btn-gold w-full justify-center disabled:opacity-60"
          >
            <Lock size={15} /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <a href="/" className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.25em] text-subtle transition-colors hover:text-gold">
          ← Back to site
        </a>
      </div>
    </div>
  );
}
